// @flow

import * as React from "react";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { loginWithRedirect } from "../../actions/user";
import Config from "../../constants/Config";
import { addToCart } from "../../actions/cart";
import useAsyncState from "../../hooks/useAsyncState";
import Store from "../../store";
import RichTextContent from "../molecules/RichTextContent";
import Accordions from "./Accordions";
import EventList from "./EventList";
import Button from "../atoms/Button";
import ServerErrorMessage from "../atoms/ServerErrorMessage";
import CategorySection from "../molecules/CategorySection";
// import LinkHandler from "../atoms/LinkHandler";

type PropsType = {
    acf: any,
    events: any,
    categories?: any,
    ID: number,
    related: any,
};

const MembershipContent = (props: any): React.Node => {
    const [state, localActions] = useAsyncState();
    const { loggedIn, profile } = useSelector((state: any): any => state.user);
    const { terms_and_conditions } = useSelector(
        (state: any): any => state.options
    );
    const dispatch = useDispatch();
    const history = useHistory();
    const hasMembership =
        profile && profile.active_memberships
            ? profile.active_memberships.filter(
                  memberships => memberships.club_id === props.id
              ).length > 0
            : false;
    const membershipObject = props.memberships.filter(
        membership =>
            (membership.acf && membership.acf.eligible_for) === profile.type
    )[0];
    const eligibleMembership =
        loggedIn && membershipObject && membershipObject.id
            ? membershipObject.id
            : 0;

    const handleFormSubmit = async (formData: any): any => {
        localActions.request();
        dispatch(
            addToCart({
                id: eligibleMembership,
                quantity: 1,
                clubDetailUrl: document.location.pathname,
            })
        )
            .then(() => {
                localActions.success();
                history.push(Config.routes.cart);
            })
            .catch((error: any) => {
                console.error(error);
                localActions.fail(error.message || "Server error.");
            });
    };

    const handleLoginToJoin = () => {
        dispatch(loginWithRedirect(document.location.pathname));
    };

    if (hasMembership) {
        return (
            <div className="club-detail-body__club-membership">
                <div className="club-detail-body__club-membership__inner">
                    <h2 className="club-detail-body__club-membership__title">
                        You're a member of this club
                    </h2>
                    <Button
                        className="button button--green-secondary club-detail-body__cta"
                        to={Config.routes.currentMembership}
                        styles={[]}
                    >
                        View my clubs
                    </Button>
                    <div
                        className="club-detail-body__club-membership__description"
                        dangerouslySetInnerHTML={{
                            __html: terms_and_conditions,
                        }}
                    />
                </div>
            </div>
        );
    }

    if (props.status === "open") {
        return (
            <div className="club-detail-body__club-membership">
                <div className="club-detail-body__club-membership__inner">
                    <h2 className="club-detail-body__club-membership__title">
                        Join the club
                    </h2>
                    <div className="club-detail-body__club-membership__details">
                        {props.memberships &&
                            props.memberships.map((membership, index) => {
                                if (
                                    membership.acf &&
                                    membership.acf.eligible_for &&
                                    membership.price
                                ) {
                                    return (
                                        <div
                                            key={index}
                                            className="club-detail-body__club-membership__details__row"
                                        >
                                            <div className="club-detail-body__club-membership__details__position">
                                                {membership.acf.eligible_for}
                                            </div>
                                            <div className="club-detail-body__club-membership__details__duration">
                                                ${membership.price}
                                            </div>
                                        </div>
                                    );
                                }

                                return null;
                            })}
                    </div>
                    <ServerErrorMessage>{state.error}</ServerErrorMessage>
                    {loggedIn ? (
                        <Button
                            loading={state.loading}
                            success={!!state.success}
                            className="button button--green club-detail-body__cta"
                            styles={[]}
                            onClick={handleFormSubmit}
                        >
                            Join club
                        </Button>
                    ) : (
                        <Button
                            className="button button--green club-detail-body__cta"
                            onClick={handleLoginToJoin}
                            styles={[]}
                        >
                            Login or sign up to join
                        </Button>
                    )}

                    <div
                        className="club-detail-body__club-membership__description"
                        dangerouslySetInnerHTML={{
                            __html: terms_and_conditions,
                        }}
                    />
                </div>
            </div>
        );
    } else if (props.status === "closed" || props.status === "not-possible") {
        if (props.membership_registration_area) {
            return (
                <div className="club-detail-body__club-membership">
                    <div className="club-detail-body__club-membership__inner">
                        <h2 className="club-detail-body__club-membership__title">
                            {props.membership_registration_area.title}
                        </h2>
                        <p className="club-detail-body__club-membership__subtitle">
                            {props.membership_registration_area.message}
                        </p>
                    </div>
                </div>
            );
        }
    }

    return null;
};

const ClubDetailBody = (props: PropsType): React.Node => {
    const state = Store.getState();
    const related = _.get(state, `page.related`) || {};

    const memberships = Array.isArray(props.acf.club_products)
        ? props.acf.club_products.map(product => related[product.product.ID])
        : [];

    return (
        <div className="club-detail-body">
            <div className="club-detail-body__container container-fluid">
                <div className="club-detail-body__row row">
                    <div className="col-xs-12 col-sm-7 col-md-8">
                        <div className="club-detail-body__left-content">
                            <div className="row">
                                {props.acf && props.acf.html ? (
                                    <div className="col-xs-12">
                                        <RichTextContent
                                            html={props.acf.html}
                                            background={false}
                                            theme={props.acf.theme}
                                        />
                                    </div>
                                ) : null}
                                {props.events.length > 0 ? (
                                    <div className="col-xs-12 col-md-11 club-detail-body__event-list">
                                        <div className="club-detail-body__event-list__inner">
                                            <EventList
                                                events={props.events}
                                                context="club-detail"
                                            />
                                        </div>
                                    </div>
                                ) : null}
                                {props.acf.club_faqs &&
                                props.acf.club_faqs.sections.length > 0 ? (
                                    <div className="col-xs-12 club-detail-body__faq">
                                        <Accordions
                                            title={props.acf.club_faqs.title}
                                            description={
                                                props.acf.club_faqs.description
                                            }
                                            accordions={
                                                props.acf.club_faqs.sections
                                            }
                                        />
                                    </div>
                                ) : null}
                                {props.categories ? (
                                    <div className="col-xs-12">
                                        <CategorySection
                                            categories={props.categories}
                                            title="Club category"
                                            type="club"
                                            section="bottom-content"
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-5 col-md-4">
                        <MembershipContent
                            status={props.acf.open_state}
                            id={props.ID}
                            memberships={memberships}
                            membership_registration_area={
                                props.acf.membership_registration_area
                            }
                        />
                        {props.categories ? (
                            <CategorySection
                                categories={props.categories}
                                title="Club category"
                                type="club"
                                section="left-content"
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

ClubDetailBody.defaultProps = {
    heroTitleSize: "heading-1",
    showRelated: true,
};

export default ClubDetailBody;
